<template>
  <vs-popup :active.sync="isActiveLocal" title="Cargar archivo">
    <div class="flex w-full items-center justify-center p-4 text-xl text-justify">
      En el cuadro inferior debe colocar el archivo que desea cargar.<br/>
      Debe seleccionar un archivo en formato de hoja electrónica.
    </div>
    <form class="flex w-full justify-center" enctype="multipart/form-data" novalidate style="width: 500px;">
      <div class="flex w-full items-center justify-center text-center dropbox p-6">
        <input type="file" :name="uploadFieldName" :disabled="isSaving" @change="filesChange" accept="*/*" class="input-file" ref="inputFile">
        <div v-if="isInitial" class="flex w-full justify-center">
          <div class="text-center">
            Arrastre archivo a este cuadro o haga click para seleccionar
          </div>
        </div>
        <div v-else class="flex w-full flex-col items-center justify-start p-4">
          <div class="flex w-full justify-center" v-for="file in sortedFiles" :key="file.name">
            <h5 class="flex w-1/3 mr-2">{{ file.name }}</h5>
          </div>
        </div>
      </div>
    </form>
    <div class="flex w-full items-center justify-center text-center p-6" v-if="isSuccess">
      <vs-button @click="loadFile">Cargar archivo{{ uploadFiles.length > 1 ? 's' : ''}}</vs-button>
    </div>
  </vs-popup>
</template>

<script>
  const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
  export default {
    name: "Upload",
    props: {
      isActive: {
        type: Boolean,
        required: true
      },
      context: {
        type: Object,
        required: true
      },
      uploadURL: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        uploadFiles: [],
        currentStatus: null,
        lines: [],
        uploadFieldName: 'photos'
      }
    },
    computed: {
      isActiveLocal: {
        get() {
          return this.isActive;
        },
        set(val) {
          if (!val) {
            this.$emit('closeFileUpload', this.lines);
          }
        }
      },
      isInitial() {
        return this.currentStatus === STATUS_INITIAL;
      },
      isSaving() {
        return this.currentStatus === STATUS_SAVING;
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS;
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED;
      },
      sortedFiles() {
        return [...this.uploadFiles].sort(function (a, b) {
          var ret = 1;
          if (a.sequence < b.sequence) {
            ret = -1;
          }
          return ret;
        });
      }
    },
    watch: {
      isActiveLocal: function () {
        if (this.isActiveLocal) {
          this.reset();
        }
      }
    },
    methods: {
      reset() {
        this.uploadFiles = [];
        this.currentStatus = STATUS_INITIAL;
        if (this.$refs.inputFile) {
          this.$refs.inputFile.value = '';
        }
      },
      filesChange(event) {
        if (event) event.preventDefault();
        var files = event.target.files;
        if (files !== undefined) {
          this.uploadFiles = [];
          for (var i = 0; i < files.length; i++) {
            const fileName = files[i].name;
            const fr = new FileReader();
            fr.readAsText(files[i]);
            fr.addEventListener('load', () => {
              this.uploadFiles.push({
                name: fileName
              });
              this.currentStatus = STATUS_SUCCESS;
            });
          }
        } else {
          this.reset();
        }
      },
      loadFile() {
        this.$vs.loading({
          text: 'Cargando archivo, espere por favor',
          type: 'point'
        });
        const self = this;
        const formData = new FormData();
        for (var i = 0; i < self.$refs.inputFile.files.length; i++) {
          formData.append('files', self.$refs.inputFile.files[i]);
        }
        formData.append('userId', this.context.userId);
        formData.append('token', this.context.token);
        // self.$http.post("http://localhost:8080/v2/stock/transactions/upload", formData, {headers: {'Content-Type': 'multipart/form-data'}, timeout: 1200000})
        self.$http.post(this.uploadURL, formData, {headers: {'Content-Type': 'multipart/form-data'}, timeout: 1200000})
          .then(response => {
            if (response.data.success) {
              self.lines = response.data.data;
              self.$vs.notify({
                title: 'Archivo cargado',
                text: `El archivo fue cargado`,
                color: 'success'
              });
              self.isActiveLocal = false;
            } else {
              self.$vs.notify({
                title: 'Error al cargar archivo',
                text: response.data.message,
                color: 'danger'
              });
            }
            self.$vs.loading.close();

          })
          .catch(error => {
            self.loginDisabled = false
            self.$vs.loading.close();
            var errorMessage = '';
            if (error.message) {
              errorMessage = error.message;
            } else if (error.response) {
              errorMessage = error.response.data.ErrorMessage;
            } else {
              errorMessage = 'Error de conectividad';
            }
            self.$vs.notify({
              title: 'Error al validar credenciales',
              text: errorMessage,
              color: 'danger'
            });
          });
      }
    },
    mounted() {
      this.reset();
    }
  }
</script>

<style scoped lang="scss">
  .dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: lightcyan;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    position: relative;
    cursor: pointer;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .dropbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
  }

  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }
</style>
